
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmTransferredIec as ObiAlarmTransferredIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-transferred-iec.js';
 
 
 

 
 export const ObiAlarmTransferredIec = createComponent({
   react: React,
   tagName: 'obi-alarm-transferred-iec',
   elementClass: ObiAlarmTransferredIecElement,
   events: {
     
   }
  });
 
 